import { Alert, Box, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

export function ErrorState({ message, onRetry }) {
  const { t } = useTranslation('common');

  return (
    <Box sx={{ py: 2 }}>
      <Alert
        severity="error"
        action={onRetry ? (
          <Button color="inherit" size="small" onClick={onRetry}>
            {t('retry')}
          </Button>
        ) : null}
      >
        {message}
      </Alert>
    </Box>
  );
}
